import React from 'react'
import { Card } from 'react-bootstrap'

const VRDevelopmentBanner = () => {
  return (
    <>
      <Card className="digital-twin-banner no-border rounded-0">
            <Card.Img src={process.env.PUBLIC_URL + "assets/vr-development/top-banner.jpg"} alt="Card image" className="banner-image rounded-0"  />
        </Card>
        <Card className="no-border rounded-0 text-center container">
            <Card.Title className='digital-twin-title'>Virtual Reality (VR) Development</Card.Title>
            <Card.Subtitle className='digital-twin-subtitle'>Taking you to other worlds</Card.Subtitle>
            <Card.Text className='digital-twin-text'>
            Anything is possible in virtual reality. Machine operators can learn their jobs without safety risks, students can visit a historical site across the globe, and games can be more interactive and immersive than ever before. 
            <br />
            <br />  The possibilities for VR are, at this point, endless. We hear new ideas every day, and are excited to be part of bringing those ideas to life. Many of the solutions we work on are making the world a better, safer place.  
            <br />
            <br />  Whether you require a complete end-to-end VR development solution, a virtual environment, or 3D assets for your own project, Paracosma can provide the resources and solutions that help you meet your goals.
            </Card.Text>
        </Card>
    </>
  )
}

export default VRDevelopmentBanner
